module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.90822012.jpg";